export default "__VITE_ASSET__ClQzQwVs__"